import styled from "styled-components"

const StyledFlagImg = styled.img`
  display: block;
  width: 24px;
  height: 16px;
  margin-right: 0.8rem;
`
const StyledDropdownWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding-left: 2.4rem;
  padding-bottom: 1.9rem;
  align-items: center;

  &:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid ${({ theme }) => theme.color.secondary02};
    position: absolute;
    right: 0;
  }

  ${({ extraStyles }) => extraStyles};
`

export { StyledFlagImg, StyledDropdownWrapper }
